/* eslint-disable camelcase */
import isEmpty from 'lodash/isEmpty';
import { useEffect, useState } from 'react';
import getSettings from '../utils/auth/getSettings';
import { appendQueryParams } from '../utils/urlUtils';

function useUserAccountActionsUrls() {
  const [authDetails, setAuthDetails] = useState({});
  let signInURL = null;
  let signOutURL = null;
  let signUpURL = null;

  useEffect(() => {
    getSettings().then(
      ({
        signinURL,
        signoutURL,
        signupURL,
        auth_redirect_params_signin,
        auth_redirect_params_signout,
        auth_redirect_params_signup,
      }) => setAuthDetails({
        signinURL,
        signoutURL,
        signupURL,
        auth_redirect_params_signin,
        auth_redirect_params_signout,
        auth_redirect_params_signup,
      }),
    );
  }, []);

  if (!isEmpty(authDetails)) {
    const {
      signinURL,
      signoutURL,
      signupURL,
      auth_redirect_params_signin,
      auth_redirect_params_signout,
      auth_redirect_params_signup,
    } = authDetails;

    signInURL = appendQueryParams(signinURL, auth_redirect_params_signin);

    signOutURL = appendQueryParams(signoutURL, auth_redirect_params_signout);

    signUpURL = appendQueryParams(signupURL, auth_redirect_params_signup);
  }

  return { signInURL, signOutURL, signUpURL };
}

export default useUserAccountActionsUrls;
